import { adminConsoleMessages, profilePageMessages } from 'azshared';
import React from 'react';
import { useIntl } from 'react-intl';
import './menu-header.scss';

export interface HeaderProps {
  userName?: string;
}

export const Header = (props: HeaderProps) => {
  const { formatMessage } = useIntl();
  const displayName = props.userName?.trim() || formatMessage(adminConsoleMessages.defaultAdminUser);

  return (
    <div className='app-menu-header admin-menu-header'>
      <svg className='app-menu-header-avatar' />
      <div className='app-menu-header-description'>
        <span className='app-menu-header-name'>{displayName.toUpperCase()}</span>
        <div className='app-menu-header-my-azimut'>{formatMessage(profilePageMessages.disclaimerMyAzimut)}</div>
      </div>
    </div>
  );
};
